import React, { Fragment, useContext } from 'react';
import Input from 'chameleon/ui-stack/ui/base/input';
import DynamicBuilderContext from '../context';

const labelClassName = 'ml-2 mb-2 text-14 font-medium';

function DefaultDynamicBuilder() {
  const { formData, onInputChange } = useContext(DynamicBuilderContext);
  const { mcqLength, frqLength } = formData;

  return (
    <Fragment>
      <div className="mb-4 flex flex-row gap-4">
        <div className="w-1/6">
          <label htmlFor="assesment-mcqs" className={labelClassName}>
            No. of MCQs
          </label>
          <Input
            label="No. of MCQs"
            placeholder="No. of MCQs"
            className={{ 'input-field-invalid': false }}
            id="assesment-mcqs"
            name="assesment-mcqs"
            type="number"
            step={1}
            min={0}
            value={mcqLength}
            onChange={onInputChange('mcqLength')}
          />
        </div>
        <div className="w-1/6">
          <label htmlFor="assesment-frqs" className={labelClassName}>
            No. of FRQs
          </label>
          {/* Number of FRQs  */}
          <Input
            label="No. of FRQs"
            placeholder="No. of FRQs"
            className={{ 'input-field-invalid': false }}
            id="assesment-frqs"
            name="assesment-frqs"
            type="number"
            step={1}
            min={0}
            value={frqLength}
            onChange={onInputChange('frqLength')}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default DefaultDynamicBuilder;
